export default "__VITE_ASSET__844a0419__"